import { AWSUser } from "@archetypes/auth";
import { Auth } from "aws-amplify";

export const getUser = async (): Promise<AWSUser | undefined> => {
  try {
    const currentUser = await Auth.currentAuthenticatedUser();
    return currentUser?.attributes as AWSUser;
  } catch (error) {
    return undefined;
  }
};

export const getJWTToken = async (): Promise<string | undefined> => {
  try {
    const session = await Auth.currentSession();
    return session.getIdToken()?.getJwtToken();
  } catch (error) {
    return undefined;
  }
};
